export class Product {
  constructor(
              public id: string,
              public name: string,
              public company_name: string,
              public company: {
                city: string,
                street: string
              },
              public oldPrice: number,
              public newPrice: number,
              public description?: string,
              public discount?: number,
              public images?: any[],
              public image?: string,
              public category?: string,
              public online?: string,
              public startDate?: string,
              public endDate?: string,
              public anbieter?: string,
              public currency?: string,
              public created_date?: string,
              public online_from?: string,
              public online_to?: string,
              public company_logo?: string,
              public company_address?: string,
              public tags?:string,
              public location?: GeoLocation){} 
}

export interface GeoLocation {
  latitude: number,
  longitude: number
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/models/Product.ts